<template>
	
	<div class="ui grid mt-30">
		<div class="ui row stackable" v-if="!loading && news.length == 0">
			<div class="sixteen wide column">
				<p class="centered">Trenutno ni novic.</p>
			</div>
		</div>
		<div class="ui row stackable recordings-row" v-else>
			<div class="four wide column">
				<div class="ui vertical fluid menu" v-if="subjects">
					<a class="item" v-for="subject in subjects" @click="filterBySubject(subject)" :class="{'active teal': isFilteredSubject(subject)}" :key="subject.id">
						{{subject.label | capitalize}} {{subject.type | school}}
					</a>
				</div>
				<button class="fluid mini ui button" @click="filteredSubjects = []" v-if="subjects" :disabled="filteredSubjects.length == 0">Počisti filter</button>
			</div>
			<div class="twelve wide column" v-if="loading">
				<div class="ui segment">
					<div class="ui active centered inline loader"></div>
				</div>
			</div>
			<div class="twelve wide column" v-if="!loading">
				<div class="ui divided items">
					<div class="item" v-for="newsItem in filteredNews" :key="newsItem.unique_id">
						<div class="image" @click="openNews(newsItem)">
							<img :src="newsItem.hero_image_url" class="cursor">
						</div>
						<div class="content">
							<a class="header" @click="openNews(newsItem)">{{newsItem.title}}</a>
							<div class="meta">{{newsItem.valid_from | date}}</div>
							<div class="description" v-if="newsItem.excerpt">
								<p v-html="newsItem.excerpt"></p>
							</div>
							<div class="extra">
								<button class="ui right floated teal button" @click="openNews(newsItem)">Preberi več</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import slugify from 'slugify'
import queryString from 'query-string'

export default {
	data() {
		return {
            loading: true,
            subjects: undefined,
            filteredSubjects: [],
			news: []
		};
	},
	mounted() {
		this.loadNews();
	},
	methods: {
		loadNews() {
            axios.get(this.route('warehouse.news.all')).then(({data}) => {
                this.loading = false
				this.subjects = data.subjects
				this.news = data.news

				this.setupInitalFilter()
            })
		},
		openNews(news) {
			let url = this.route('warehouse.news.single', news.unique_id)
			if (news.loginRequred) {
				location = this.route('login') + '?return-url=' + url
			} else {
				location = url
			}
		},
		setupInitalFilter() {
			if (location.hash != '') {
				let subjects = Object.keys(queryString.parse(location.hash))
				subjects.forEach(subject => {
					this.subjects.forEach(item => {
						if (slugify(`${item.label}-${item.type}`, { lower: true }) == subject) {
							this.filterBySubject(item)
						}
					})
				})
			} else {
				this.subjects.forEach(subject => {
					if (subject.ownSubject) {
						this.filterBySubject(subject);
					}
				});
			}
		},
        filterBySubject(subject) {
            if (!this.isFilteredSubject(subject)) {
                this.filteredSubjects.push(subject)
            } else {
                let index = this.filteredSubjects.indexOf(subject)
                this.filteredSubjects.splice(index, 1)
            }
        },
        isFilteredSubject(subject) {
            return this.filteredSubjects.indexOf(subject) >= 0
		},
		hasFilteredSubject(news, subject) {
			return news.subjects.reduce((acc, sub) => {
				if (sub.id == subject.id) {
					return true
				}
				return acc
			}, false)
		}
	},
    filters: {
        capitalize(text) {
            return text.charAt(0).toUpperCase() + text.slice(1)
		},
		school(text) {
			if (text == 'os') {
				return '(OŠ)'
			}
			if (text == 'ss') {
				return '(SŠ)'
			}
			return text.toUpperCase()
		},
		date(value) {
            let date = new Date(Date.parse(value))
            return date.toLocaleDateString('sl-SI')
        }
	},
	watch: {
		filteredSubjects() {
			let hash = []
			this.filteredSubjects.forEach(subject => {
				hash.push(slugify(`${subject.label}-${subject.type}`, { lower: true }))
			})
			location.hash = '#' + hash.join('&')
		}
	},
	computed: {
		filteredNews() {
			if (this.filteredSubjects.length == 0) {
				return this.news
			}

			let filteredNews = this.news.filter(item => {
				for (let sub of this.filteredSubjects) {
					if (this.hasFilteredSubject(item, sub)) {
						return true
					}
				}
				return false
			});
			return filteredNews
		}
	}
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/News.vue